exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.w-img[data-v-b6d1dd52] {\n  width: 30px;\n}\n.h-img[data-v-b6d1dd52] {\n  height: 16.8px;\n}\n.custom-fonts[data-v-b6d1dd52] {\n  font-size: 14px;\n  font-weight: 300;\n}\n", ""]);

// exports
